<template>
    <div class="avatar-box m-2 d-flex justify-content-center" v-if="avatar.id">
        <div :id="avatar.id" class="avatar-image position-relative d-flex justify-center align-center">
            <img
                :src="`https://assets.beeverso.org/avatar/${avatar.name}/${avatar.value}`"
                class="avatar-img transition-all"
                @load="handleLoaded"
                alt="Av"
            />
            <v-skeleton-loader
                v-if="!loaded"
                class="rounded-circle position-absolute opacity-none grey lighten-1"
                height="120"
                width="120"
                type="image"
                :transition="'scale-transition'"
            ></v-skeleton-loader>
        </div>
    </div>
</template>

<script>
import { DEFAULT_AVATAR } from "@/constants/DefaultConstants"

export default {
    props: {
        avatar: {
            type: Object,
            default: DEFAULT_AVATAR,
        },
    },
    data() {
        return {
            loaded: false,
        }
    },
    methods: {
        setActiveAvatar() {
            document.querySelector('.avatar-active').classList.toggle('avatar-active')
            document
                .querySelector(`#${this.avatar.id}`)
                .children()
                .classList.toggle('avatar-active')
        },
        handleLoaded() {
            this.loaded = true
        },
    },
}
</script>

<style lang="scss">
.avatar-box,
.avatar-image img{
    border-radius: 100%;
}

.avatar-active .avatar-img {
    padding: 0;
}
.avatar-img {
    display: block;
    /* padding: .5vw; */
    width: 100%;
}

.avatar-active {
    .avatar-img{
        background-color: #FFF;
        border-radius: 100%;
        z-index: 1;
    }
    &::after{
        content: '';
        background: linear-gradient(147.2deg, #A295DA 4.28%, #7764CA 33.93%, #6857B2 62.04%, #514585 95.25%),
        linear-gradient(0deg, rgba(174, 236, 180, 0.3), rgba(174, 236, 180, 0.3));
        border-radius: 100%;
        display: block;
        height: 112%;
        position: absolute;
        left: -6%;
        top: -6%;
        width: 112%;
        z-index: 0;
    }
}

.avatar-box,
.avatar-image {
    border-radius: 100%;
}
</style>
